import script from "./SubHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubHeader.vue?vue&type=script&setup=true&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=5c7cef65&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7cef65"]])

export default __exports__